var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7084 12.862C58.7084 34.6235 48.8168 52.2553 36.6872 52.2553C24.5576 52.2553 14.666 34.6235 14.666 12.862C14.666 1.95649 58.7084 1.95649 58.7084 12.862Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7188 67.241C25.7188 62.0232 31.0108 57.8069 37.5392 57.8069C44.0677 57.8069 49.372 62.0232 49.372 67.241C49.372 72.4588 25.7188 72.4341 25.7188 67.241Z",
    fill: "#767676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4383 10.7107C14.9376 9.95646 7.71678 9.54843 4.98422 14.0615C3.09245 17.2021 4.71222 21.3071 6.15886 24.2869C8.08381 28.1702 10.6316 31.7121 13.7012 34.772C16.273 37.3686 20.0936 40.7688 24.0626 40.4473C26.4243 40.2495 26.4366 36.5278 24.0626 36.738C22.9957 36.7793 21.942 36.49 21.0457 35.9096C19.6998 35.133 18.4541 34.1946 17.3364 33.1152C14.6278 30.5843 12.3072 27.6679 10.4493 24.46C9.6089 23.0621 8.92079 21.5782 8.39684 20.0335C7.91026 18.896 7.76836 17.6406 7.98879 16.4231C8.14648 16.0426 8.3836 15.7002 8.68425 15.4188C8.98491 15.1373 9.34217 14.9233 9.73219 14.791C10.8023 14.3881 11.9286 14.1545 13.0706 14.0986C14.4039 13.9935 15.7434 13.9935 17.0767 14.0986L17.8186 14.1728H18.1524H18.4739C20.7984 14.5684 21.8123 10.9951 19.4507 10.5871L19.4383 10.7107Z",
    fill: "#767676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2834 14.321H55.6667C55.9263 14.321 55.1597 14.321 55.6667 14.321L56.3467 14.2468C57.4516 14.1339 58.5624 14.0885 59.6728 14.1108C60.8761 14.1096 62.0741 14.2719 63.2338 14.5931C63.7151 14.719 64.1769 14.9104 64.6062 15.1618C64.9455 15.3635 65.2434 15.6279 65.4841 15.9408C65.71 16.3916 65.8439 16.8829 65.8779 17.3861C65.9119 17.8892 65.8452 18.3941 65.6819 18.8712C65.2976 20.4171 64.7202 21.9084 63.9633 23.31C62.2293 26.5915 60.0212 29.5996 57.41 32.2372C56.1226 33.577 54.6779 34.756 53.1072 35.7487C52.1047 36.463 50.9008 36.8398 49.6699 36.8244C47.2835 36.6142 47.2959 40.3359 49.6699 40.5338C53.1072 40.8182 56.4209 38.1969 58.8072 36.0331C62.0387 33.0582 64.7619 29.5749 66.8689 25.7211C68.4763 22.7907 70.4175 18.7104 69.2676 15.2978C68.1177 11.8852 64.6804 10.8837 61.5522 10.5251C59.1277 10.2817 56.6813 10.3732 54.2818 10.7972C51.9326 11.2052 52.9341 14.7785 55.271 14.3829L55.2834 14.321Z",
    fill: "#767676"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8174 35.2046V62.9382C33.8174 67.7109 41.2361 67.7109 41.2361 62.9382V35.2046C41.2361 30.4319 33.8174 30.4196 33.8174 35.2046Z",
    fill: "#767676"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9994 9.15251C54.9994 30.914 45.1078 48.5458 32.9782 48.5458C20.8486 48.5458 10.957 30.914 10.957 9.15251C10.957 -1.75298 54.9994 -1.75298 54.9994 9.15251Z",
    fill: "url(#paint0_linear_457_3817)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0107 63.5317C22.0107 58.3138 27.3027 54.0975 33.8312 54.0975C40.3597 54.0975 45.664 58.3138 45.664 63.5317C45.664 68.7495 22.0107 68.7247 22.0107 63.5317Z",
    fill: "url(#paint1_linear_457_3817)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7293 7.0011C11.2287 6.24687 4.00779 5.83884 1.27524 10.3519C-0.616531 13.4925 1.00323 17.5975 2.44988 20.5773C4.37483 24.4606 6.92266 28.0025 9.99223 31.0624C12.5641 33.659 16.3847 37.0592 20.3537 36.7377C22.7153 36.5399 22.7276 32.8182 20.3537 33.0284C19.2867 33.0697 18.233 32.7804 17.3368 32.2C15.9908 31.4234 14.7451 30.485 13.6274 29.4056C10.9188 26.8747 8.59817 23.9583 6.74036 20.7504C5.89992 19.3525 5.21181 17.8686 4.68785 16.3239C4.20127 15.1864 4.05937 13.931 4.2798 12.7135C4.4375 12.333 4.67461 11.9906 4.97527 11.7092C5.27592 11.4277 5.63319 11.2137 6.0232 11.0814C7.09328 10.6785 8.21961 10.4449 9.36163 10.389C10.6949 10.2839 12.0344 10.2839 13.3677 10.389L14.1096 10.4632H14.4434H14.7649C17.0894 10.8588 18.1033 7.28549 15.7417 6.87746L15.7293 7.0011Z",
    fill: "url(#paint2_linear_457_3817)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5744 10.6116H51.9577C52.2174 10.6116 51.4508 10.6116 51.9577 10.6116L52.6377 10.5374C53.7426 10.4244 54.8534 10.379 55.9638 10.4014C57.1671 10.4002 58.3651 10.5624 59.5248 10.8836C60.0061 11.0095 60.4679 11.2009 60.8972 11.4523C61.2365 11.654 61.5344 11.9184 61.7751 12.2313C62.0011 12.6821 62.1349 13.1735 62.1689 13.6766C62.2029 14.1797 62.1362 14.6846 61.9729 15.1617C61.5886 16.7076 61.0112 18.1989 60.2543 19.6006C58.5203 22.8821 56.3122 25.8901 53.7011 28.5277C52.4137 29.8675 50.9689 31.0466 49.3982 32.0393C48.3957 32.7536 47.1918 33.1303 45.9609 33.115C43.5746 32.9048 43.5869 36.6265 45.9609 36.8243C49.3982 37.1087 52.7119 34.4874 55.0983 32.3236C58.3297 29.3488 61.0529 25.8655 63.1599 22.0116C64.7673 19.0812 66.7086 15.001 65.5587 11.5884C64.4088 8.17575 60.9714 7.17423 57.8432 6.81566C55.4187 6.57224 52.9723 6.66378 50.5728 7.08768C48.2236 7.49571 49.2251 11.0691 51.562 10.6734L51.5744 10.6116Z",
    fill: "url(#paint3_linear_457_3817)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1104 31.4951V59.2286C30.1104 64.0013 37.5291 64.0013 37.5291 59.2286V31.4951C37.5291 26.7224 30.1104 26.71 30.1104 31.4951Z",
    fill: "url(#paint4_linear_457_3817)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_457_3817",
    x1: 32.9782,
    y1: -0.751459,
    x2: 32.9782,
    y2: 180.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_457_3817",
    x1: 33.8312,
    y1: -0.751426,
    x2: 33.8312,
    y2: 180.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_457_3817",
    x1: 11.2781,
    y1: -0.751442,
    x2: 11.2781,
    y2: 180.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_457_3817",
    x1: 55.0488,
    y1: -0.751417,
    x2: 55.0488,
    y2: 180.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_457_3817",
    x1: 33.8321,
    y1: -0.751573,
    x2: 33.8321,
    y2: 180.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.c3bc71e1bc34678b0159a3608c913e12.svg";
export { ForwardRef as ReactComponent };